export default __webpack_public_path__ + "static/media/01.bbd6a53d.jpg";